/**
 * External dependencies
 */
import axios, { AxiosResponse } from 'axios';
import Utility from '@naruto/naruto-models/src/core/utility';

/**
 * Internal dependencies
 */
import { EnvConfig, EnvConfigFromNginx } from './types';

class Env {
  public tools: Utility;

  public config: EnvConfig;

  constructor() {
    this.tools = new Utility();
    this.config = {
      Debug: this.tools.parseBool(process.env.DEBUG) || false,
      Release: this.tools.parseBool(process.env.RELEASE) || false,
      NodeEnv: process.env.NODE_ENV || 'development',
      EnvName: process.env.APP_ENV || 'dev',
      APIUrl: process.env.API_URL || 'http://localhost:10230/',
      I18nLocalName: process.env.I18N_NAME || 'naruto-dev-lang',
      JwtTokenLocalName: process.env.JWT_TOKEN_NAME || 'naruto-dev-token',
      ScrollRecordName: process.env.SCROLL_RECORD_NAME || 'naruto-dev-scroll-record',
      CallbackSendFromLocal: this.tools.parseBool(process.env.CALL_BACK_SEND_FROM_LOCAL) || false,
      EnableAutoLogout: this.tools.parseBool(process.env.ENABLE_AUTO_LOGOUT) || false,
      AutoLogoutTime: Number(process.env.AUTO_LOGOUT_TIME) || 0,
      AutoLogoutLocalName: process.env.AUTO_LOGOUT_NAME || 'naruto-dev-auto-logout',
      GitCommitHash: process.env.GIT_COMMIT_HASH || '',
      GitCommitTime: process.env.GIT_COMMIT_TIME || ''
    };
  }

  async initializeFromNginx(): Promise<boolean> {
    if (process.env.LOAD_ENV_FROM_NGINX && this.tools.parseBool(process.env.LOAD_ENV_FROM_NGINX)) {
      try {
        const envVariableInNginxResult = await axios.post<unknown, AxiosResponse<EnvConfigFromNginx>>('/_system_info');
        const variableInNginxData = envVariableInNginxResult.data;
        this.config = {
          ...this.config,
          Debug: variableInNginxData.debug,
          Release: variableInNginxData.release_page,
          EnvName: variableInNginxData.app_env,
          APIUrl: variableInNginxData.api_url,
          I18nLocalName: variableInNginxData.i18n_name,
          JwtTokenLocalName: variableInNginxData.jwt_token_name,
          ScrollRecordName: variableInNginxData.scroll_record_name,
          CallbackSendFromLocal: variableInNginxData.call_back_send_from_local,
          EnableAutoLogout: variableInNginxData.enable_auto_logout,
          AutoLogoutTime: Number.isFinite(Number(variableInNginxData.auto_logout_time))
            ? Number(variableInNginxData.auto_logout_time)
            : 0,
          AutoLogoutLocalName: variableInNginxData.auto_logout_name
        };
        return true;
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.warn(`initialize failed, reason ::: ${JSON.stringify(error)}`);
        return false;
      }
    }
    return true;
  }

  updateEnvConfig(envConfig: EnvConfig): void {
    this.config = { ...this.config, ...envConfig };
  }
}

const ENVInstance = new Env();

export default ENVInstance;
